import fragment from 'graphql/fragments/sales/InvoiceGenerationCriteriaFragment.graphql';
import invoiceMutation from 'graphql/mutations/sales/PostInvoiceMutation.graphql';

const InvoiceGenerationCriteria = {
  type: 'SalesOrder',
  title: 'Invoice Generation Criteria',
  formTitle: 'Invoice Generation Criteria',
  formUrl: '/Sales/InvoiceGenerationCriteria/Results/',
  postInvoice: invoiceMutation,
  fragment,
  screenReference: 'SALES_INVOICE_GENERATION_RESULTS',
};

export default InvoiceGenerationCriteria;
